import React from 'react'

type Props = {}

export default function CursorPunks({}: Props) {
  return (
    <div><br></br><br></br><br></br><br></br><br></br><br></br>CursorPunks</div>
  )
}